import React from 'react';

const Testimonials = () => {
    return (
        <section className="py-16 bg-gray-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-4xl font-bold text-center mb-12">What Our Customers Say</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <p className="text-gray-700 italic">"Vertikal planned the best trip I've ever taken! Every detail was perfect."</p>
                        <h3 className="mt-4 font-semibold text-lg">- John Doe</h3>
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <p className="text-gray-700 italic">"I can't thank Vertikal enough for the amazing experiences!"</p>
                        <h3 className="mt-4 font-semibold text-lg">- Jane Smith</h3>
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <p className="text-gray-700 italic">"They made trip planning so easy. I will definitely use them again!"</p>
                        <h3 className="mt-4 font-semibold text-lg">- Emily Johnson</h3>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
